module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-preact/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Tyhjä sivupohja","short_name":"Tyhjä sivupohja","start_url":"https://danitestaa.c32.testitili.com","scope":"https://danitestaa.c32.testitili.com","icon":"src/images/favicon.png","legacy":true,"display":"browser","cache_busting_mode":"query","include_favicon":true,"theme_color_in_head":true,"cacheDigest":"693c0be9dbd4ecd7b1fd84cfe5a7c8b1"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
